import ErrorMessage from 'lib/ErrorMessage'
import React from 'react'
import "./index.scss"
import Table from './Table'

const CheckBoxQuestion = (props) => {
    const { options, label, sublabel, onChange, name, tablecontent, table, value, error,
        isEditable // is used when RM requests to resend certain fields to the applicant
        // when editable is true only that field will be editable and rest will be disabled
       } = props

    const errActive = error && error?.length !== 0;
    const errorClass = errActive ? "error_outline" : ""
    let checkbox = [];

//TODO : need to add the isEditable code

    return (
        <div className={`card_container`}>
            <p>{sublabel}</p>
            <label className='question_label'>{label}</label>
            {table ? <Table item={tablecontent} /> : ""}
            {
                options?.map(option => {
                    const { id, label } = option
                    let radioId = name + id

                    return (
                        <div className='radio_options' key={radioId}>
                            <input
                                id={radioId}
                                type={`checkbox ${!isEditable && "radioDisabled"}`}
                                name={name}
                                className="option_input"
                                onChange={onChange}
                                value={option.value}
                                disabled = {isEditable ? false:true}
                                // checked={value?.length ? value?.id?.includes(option?.id) ? true:false : checkbox.includes(option?.id)}
                            />
                            <label className='option_label' htmlFor={radioId}>
                                {label}
                            </label>
                        </div>
                    )
                })
            }

        </div>
    )
}

export default CheckBoxQuestion;